import React, { useContext } from "react";
import CartItems from "../components/cartItems/cartItems";
// import PayButton from "../components/payButton/payButton";
import './css/cart.css';
import { ShopContext } from "../context/shopContext";

const Cart = () => {
    const { itemsInCart } = useContext(ShopContext);

    const alertBox = () => {
        // Simplified the condition to return a boolean directly
        return itemsInCart() > 1;
    };

    return (
        <div>
            {/* Conditional rendering for the alert box */}
            {alertBox() && (
                <div className='alert-box'>
                    <p>Please be aware that we do not yet support sending to multiple addresses!</p>
                </div>
            )}

            {/* Rendering CartItems component */}
            <CartItems />
        </div>
    );
};

export default Cart;
